import { StationData } from "@/models/Shift";
import swal from "sweetalert2";

export const LOCAL_STORAGE_KEY_PREFIX = 'kupa.bookitpms.com';
export const LOCAL_STATION_DATA_KEY_PREFIX = "stationData";


export function getItem<Key extends string>(key: Key): string | null {
    return localStorage.getItem(wrapKey(key));
}

export function setItem<Key extends string>(key: Key, value: string) {
    localStorage.setItem(wrapKey(key), value);
}

export function wrapKey<Key extends string>(key: Key): WrappedKey<Key> {
    return `${LOCAL_STORAGE_KEY_PREFIX}.${key}`;
}

export function getStationDataFromStorage(): StationData | undefined {
    const stationDataJson = getItem(LOCAL_STATION_DATA_KEY_PREFIX);
  
    if(!stationDataJson){
      // swal.fire({
      //   icon: "error",
      //   text: "Station data not added for this Cashier",
      // });
      // return;
      // TODO: Temporary solution on empty CashierGuid need to delete and uncomment swal
      return {
        cashierGuid: ""
      }
    }
  
    const stationData: StationData = JSON.parse(stationDataJson) as StationData;
    return stationData;
}

type WrappedKey<Key extends string> = `${typeof LOCAL_STORAGE_KEY_PREFIX}.${Key}`